// extracted by mini-css-extract-plugin
export default {"dcuiThemingFooterContainer":"dcui-theming-footer-container__dcui-theming-footer-container__LCQSx"};